import { useEffect, useState } from "react";
import { useNavigate }         from "react-router-dom";
import { Button }              from "antd";
import { useRouterStore }      from "@stores";
import { SubscriptionStatusEnum } from "@enums";
import "../css/subscription-blocked.css";

const BLOCKED_INFO: Record<string, {
  emoji:    string;
  title:    string;
  message:  string;
  color:    string;
}> = {
  [SubscriptionStatusEnum.EXPIRED]: {
    emoji:   "⏰",
    title:   "Tu suscripción ha vencido",
    message: "El período de tu plan ha expirado. Contacta a tu administrador para renovar y seguir usando ON-AIR.",
    color:   "#ff4d4f",
  },
  [SubscriptionStatusEnum.SUSPENDED]: {
    emoji:   "⚠️",
    title:   "Cuenta suspendida",
    message: "Tu acceso ha sido suspendido temporalmente. Contacta a tu administrador para más información.",
    color:   "#fa8c16",
  },
  [SubscriptionStatusEnum.CANCELLED]: {
    emoji:   "🚫",
    title:   "Suscripción cancelada",
    message: "Tu suscripción ha sido cancelada. Si crees que es un error, contacta a soporte.",
    color:   "#ff4d4f",
  },
};

const DEFAULT_INFO = {
  emoji:   "🔒",
  title:   "Acceso restringido",
  message: "No tienes una suscripción activa. Contacta a tu administrador.",
  color:   "#888780",
};

const SubscriptionBlockedPage = () => {
  const navigate = useNavigate();
  const reset    = useRouterStore((s) => s.reset);
  const [code, setCode] = useState<string>("");

  useEffect(() => {
    const blocked = sessionStorage.getItem("subscription_blocked_code") ?? "";
    setCode(blocked);
  }, []);

  const info = BLOCKED_INFO[code] ?? DEFAULT_INFO;

  const handleLogout = () => {
    sessionStorage.removeItem("subscription_blocked_code");
    localStorage.removeItem(process.env.REACT_APP_TOKEN!);
    reset();
    navigate("/login", { replace: true });
  };

  return (
    <div className="sb-page">
      <div className="sb-card">

        <div className="sb-emoji">{info.emoji}</div>

        <div
          className="sb-indicator"
          style={{ background: `${info.color}18`, color: info.color }}
        >
          Suscripción inactiva
        </div>

        <h2 className="sb-title">{info.title}</h2>
        <p className="sb-message">{info.message}</p>

        <div className="sb-divider" />

        <div className="sb-actions">
          <Button
            type="primary"
            href="mailto:soporte@stockify.com"
            style={{ backgroundColor: "#534ab7", borderColor: "#534ab7" }}
          >
            Contactar soporte
          </Button>
          <Button onClick={handleLogout}>
            Cerrar sesión
          </Button>
        </div>

        <p className="sb-footer">ON-AIR — Gestión para radios</p>
      </div>
    </div>
  );
};

export default SubscriptionBlockedPage;